<script lang="ts">
    import RewardsCurrency from "@apps/rewards/components/RewardsCurrency.svelte";
    import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
    import { DiscountRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    type DiscountReward<T = boolean> = T extends true
        ? DiscountRewardEntity
        : Omit<DiscountRewardEntity, "discountCode">;

    export let reward: DiscountReward;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;

    const { fixedAmount, percentage, freeShipping } = REWARDS_DISCOUNT_TYPES;
    const formattedDiscount = Math.abs(reward.discountValue || 0);
</script>

{#if reward.discountType === fixedAmount}
    <RewardsCurrency
        let:amount
        amount={formattedDiscount}
        {currencyFormatter}
        {sanitizer}
    >
        <slot
            name="fixed_discount"
            reward={{ reward, formattedDiscount: amount }}
        />
    </RewardsCurrency>
{/if}

{#if reward.discountType === percentage}
    <slot name="percentage_discount" reward={{ reward, formattedDiscount }} />
{/if}

{#if reward.discountType === freeShipping}
    <slot name="free_shipping" reward={{ reward, formattedDiscount }} />
{/if}
